// Busiest / slowest trading-day highlights for daily sales charts.
export const EXTREME_COLOURS = { peak: "#059669", low: "#D97706" };

// Flags the highest and lowest completed traded day (date set, value > 0, not today). Needs 2+ days.
export function markExtremes(series) {
  const traded = series.filter((d) => d.date && !d.isToday && Number(d.value) > 0);
  if (traded.length < 2) return series;
  const peak = traded.reduce((a, b) => (b.value > a.value ? b : a));
  const low = traded.reduce((a, b) => (b.value < a.value ? b : a));
  if (peak === low) return series;
  return series.map((d) => (d === peak ? { ...d, extreme: "peak" } : d === low ? { ...d, extreme: "low" } : d));
}

export function ExtremeTag({ x, y, width, value, fontSize = 9 }) {
  if (value !== "peak" && value !== "low") return null;
  return (
    <text
      x={x + width / 2}
      y={y - 3}
      textAnchor="middle"
      fontSize={fontSize}
      fontFamily="ui-monospace, monospace"
      fontWeight={600}
      fill={EXTREME_COLOURS[value]}
      data-testid={`extreme-tag-${value}`}
    >
      {value === "peak" ? "Peak" : "Low"}
    </text>
  );
}

export function ExtremeBadge({ extreme }) {
  if (!extreme) return null;
  return (
    <p
      className="font-mono text-[11px] uppercase tracking-[0.14em] font-semibold mt-1"
      style={{ color: EXTREME_COLOURS[extreme] }}
      data-testid={`tooltip-extreme-${extreme}`}
    >
      {extreme === "peak" ? "Busiest day" : "Slowest day"}
    </p>
  );
}

export const extremeCellProps = (d) =>
  d.extreme ? { stroke: EXTREME_COLOURS[d.extreme], strokeWidth: 2 } : {};
